import React, { Component } from "react";

import ListUser from "./interface/list_user";

import ListQuestionAnswer from "./interface/list_question_answer";

import { Link } from "react-router-dom";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";
let strings = new LocalizedStrings({ en });

class ListOfQuestion extends Component {
  state = { fullscreen: false };
  render() {
    const self = this;
    var questions = this.props.list.questions.map(function(question) {
      return (
        <ListQuestionAnswer
          key={question.id}
          question={question}
          addAnswer={self.props.addAnswer}
          user={self.props.user}
          list_fullscreen={self.list_fullscreen}
          history={self.props.history}
          removeAnswer={self.props.removeAnswer}
          updateAnswer={self.props.updateAnswer}
          list={self.props.list}
        />
      );
    });

    var classList = this.state.fullscreen
      ? "center profilePage page_top_nav list pb-4 list_fullscreen"
      : "center profilePage page_top_nav list pb-4";

    return (
      <div className={classList}>
        <div className="max_width_500">
          <ListUser
            user={this.props.list.user}
            list={this.props.list}
            questionNumber={this.props.list.question_number}
            history={this.props.history}
          />
          {this.renderLogin()}
          {questions}
        </div>
      </div>
    );
  }

  // TO BE FIX:
  // FIXING FULL SCREEN
  list_fullscreen = e => {
    const fullscreen = !this.state.fullscreen;
    this.setState({ fullscreen });
  };

  renderLogin() {
    if (this.props.user == null) {
      // Render Sign In
      const signInUrl = "/sign_in?list=" + this.props.list.name;
      const signupUrl = "/sign_up?list=" + this.props.list.name;
      return (
        <div className="pb-3" style={{ backgroundColor: "#f0f0f0" }}>
          <Link to={signInUrl}>
            <button className="btn btn_primary btn_yaystack mr-2 btn_sign_in">
              {strings.sign_in}
            </button>
          </Link>
          <Link to={signupUrl}>
            <button className="btn btn_primary btn_yaystack btn_sign_in">
              {strings.sign_up}
            </button>
          </Link>
        </div>
      );
    }
    return <div />;
  }
}

export default ListOfQuestion;



// WEBPACK FOOTER //
// ./src/components/list/list_of_question.jsx